export const labelFontFamily = 'Helvetica, Arial, Courier';
export const animationDuration = 3000;
export const animationEasing = 'easeOutQuart';
export const xLabelFormat = {
  autoSkip: false,
  fontColor: '#424242',
  fontFamily: labelFontFamily,
  fontSize: 14,
  lineHeight: 1.5,
  maxRotation: 0
};

export const determineXLabels = function () {
  const xLabels = [];
  const xLabelMin = 1976;
  const xLabelMax = 2022;
  let ignoreTickUntilEnd = false;
  let xLabelTick = 5;
  if (window.innerWidth < 1024) {
    xLabelTick = 9;
  }
  for (let i = xLabelMin; i <= xLabelMax; i++) {
    if ((i - xLabelMin) % xLabelTick === 0) {
      if (
        (xLabelMax - i) <= (xLabelTick / 2) &&
        i !== xLabelMax
      ) {
        ignoreTickUntilEnd = true;
        xLabels.push('');
        continue;
      }
      xLabels.push(i.toString(10));
      continue;
    }
    if (!ignoreTickUntilEnd || i + 1 <= xLabelMax) {
      xLabels.push('');
    } else {
      xLabels.push(i);
    }
  }
  return xLabels;
};

export const determineQuarterlyXLabels = (
  firstYear,
  lastYear,
  startingQuarter = 1,
  endingQuarter = 4
) => (
  [...Array((lastYear + 1) - firstYear).keys()]
    .map((key) => key + firstYear)
    .flatMap((year) => {
      const quarters = (() => {
        if (year === firstYear) {
          return (
            [...Array(5 - startingQuarter).keys()]
              .map((key) => key + startingQuarter)
          );
        }
        if (year === lastYear) {
          return (
            [...Array(endingQuarter).keys()]
              .map((key) => key + 1)
          );
        }
        return (
          [...Array(4).keys()]
            .map((key) => key + 1)
        );
      })();
      return (
        quarters.map(
          (quarter) => `Q${quarter} ${year}`
        )
      );
    }).map(
      (quarter, index) => {
        const n = window.innerWidth >= 1024 ? 2 : 4;
        return (index - 1) % n !== 0 ? '' : quarter;
      }
    )
);
